import { useEffect, useState } from "react";

import { isLang, Lang } from "config/i18n/languages";

export type { Lang } from "config/i18n/languages";

/**
 * Same resolution rule the existing pages use: `sessionStorage.lang` wins,
 * otherwise the browser language (if the site has it), otherwise English.
 * NavBar writes the key on first visit and reloads the page on a switch, so
 * a one-time read is enough.
 */
export const resolveLang = (): Lang => {
  let lang: string | null = null;
  try {
    lang = sessionStorage.getItem("lang");
  } catch {
    lang = null;
  }
  if (lang === null) {
    lang = navigator.language.split("-")[0];
  }
  return isLang(lang) ? lang : "en";
};

const useLang = (): Lang => {
  const [lang, setLang] = useState<Lang>(() => resolveLang());

  useEffect(() => {
    setLang(resolveLang());
  }, []);

  return lang;
};

export default useLang;
